import { render, staticRenderFns } from "./Internals.vue?vue&type=template&id=190bcd07&"
import script from "./Internals.vue?vue&type=script&lang=js&"
export * from "./Internals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports